<template>
  <div>
    <div>
      <canvas id="counselor_map_canvas"></canvas>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js';
import * as ChartGeo from 'chartjs-chart-geo';
import AdminClient from '@/api/AdminClient';
import us from './states-10m.json';

export default {
  name: 'CounselorsByState',

  data() {
    return {
      adminClient: new AdminClient(this.$http),
      chart: null
    };
  },

  async mounted() {
    this.mapBuild();
  },

  methods: {
    mapBuild() {
      const canvas = document.getElementById('counselor_map_canvas');
      if (!canvas) {
        return;
      }

      const { $router } = this;

      const nation = ChartGeo.topojson.feature(us, us.objects.nation)
        .features[0];
      const states = ChartGeo.topojson.feature(us, us.objects.states).features;

      this.adminClient.getCounselorByState().then((res) => {
        const mapData = res.results;

        states.forEach((s) => {
          s.counselors = mapData.filter(
            (each) => each.state === s.properties.name
          );
        });

        this.chart = new Chart(canvas.getContext('2d'), {
          type: 'choropleth',
          data: {
            labels: states.map((d) => d.properties.name + '  Total Counselors'),
            datasets: [
              {
                label: 'States',
                outline: nation,
                data: states.map((d) => ({
                  feature: d,
                  value: d.counselors.length ? d.counselors[0].total : 0
                }))
              }
            ]
          },
          options: {
            legend: {
              display: false
            },
            scale: {
              projection: 'albersUsa'
            },
            geo: {
              colorScale: {
                display: true,
                position: 'bottom',
                quantize: 5,
                legend: {
                  position: 'bottom-right'
                }
              }
            },
            onClick(e, a) {
              $router.push({
                name: 'accounts-counselors',
                query: {
                  active: true,
                  stateId: a[0].feature.counselors[0].state_id
                }
              });
            }
          }
        });
      });
    }
  }
};
</script>
